var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7629_76496",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 30,
    height: 30
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 29.3776C23.3653 29.3776 29.3346 23.4083 29.3346 16.0443C29.3346 8.68027 23.3653 2.71094 16.0013 2.71094C8.6373 2.71094 2.66797 8.68027 2.66797 16.0443C2.66797 23.4083 8.6373 29.3776 16.0013 29.3776Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 16.0484V11.4297L17.334 13.739L21.334 16.0484L17.334 18.3577L13.334 20.667V16.0484Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2.66667,
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7629_76496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0390625H32V32.0391H0V0.0390625Z",
    fill: "#785607"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcons);
export default __webpack_public_path__ + "static/media/playIcons.bc35548d45f4b9b94d625139c3aebbe3.svg";
export { ForwardRef as ReactComponent };